export const SET_GRID_INSTANCE = "grid/SET_GRID_INSTANCE";
export const setGridInstance = (gridInstance) => ({
  type: SET_GRID_INSTANCE,
  gridInstance,
});

export const SET_GRID_STATE_ID = "grid/SET_GRID_STATE_ID";
export const setGridStateId = (gridStateId) => ({
  type: SET_GRID_STATE_ID,
  gridStateId,
});

export const DELETE_COLUMN = "grid/DELETE_COLUMN";
export const deleteColumn = (columnDefinition) => ({
  type: DELETE_COLUMN,
  payload: columnDefinition,
});
